import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import { getAllOrder } from "../../../services";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../global/ConfirmDialog";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer></GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "الطلبات",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Order = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [loginInput, setLogin] = useState({
    id: "",
    status_type: "Complete",
  });
  const [loginInput1, setLogin1] = useState({
    id: "",
    status_type: "Accept",
  });
  useEffect(() => {
    setIsLoading(true);

    getAllOrder()
      .then((res) => {
        setUsers(res.data.original.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleView = (id) => () => {
    navigate(`/vieworder/${id}`, { state: { id: id } });
  };
  const handleActiveunpaid = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    const data = {
      order_id: id,
      status_type: loginInput1.status_type,
    };

    axios
      .post(
        `${BaseUrl}/api/TransferOrder`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(users.filter((row) => row.id !== id));
      });
  };
  const handleActivepaid = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    const order_id = id;

    const data = {
      order_id: order_id,
      status_type: loginInput.status_type,
    };

    axios
      .post(
        `${BaseUrl}/api/TransferOrder`,
        data,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(users.filter((row) => row.id !== id));
      });
  };

  const handleDeleteClick = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    axios
      .delete(
        `${BaseUrl}/api/order/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(users.filter((row) => row.id !== id));
      })
      .catch((err) => {});
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: "from_staff_name",
      headerName: "الطلب من ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "to_staff_name",
      headerName: "الطلب إلى ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "order_type",
      headerName: "نوع الطلب",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
         renderCell: (params) => {
        const isActive = params.value === "Paid";
        return isActive ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>مدفوع</p>
        ) : (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>غير مدفوع</p>
        );
      },
    },
    {
      field: "status_type",
      headerName: "نوع الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount",
      headerName: "كمية الرصيد ",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      width: 900,
      minWidth: 500,
      maxWidth: 200,
      cellClassName: "actions",
      renderCell: ({ id }) => {
        return (
          <Box>
            <Button
              variant="contained"
              color="primary"
              className="activationbtn"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد القيام بهذه العملية",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleActivepaid(id);
                  },
                });
              }}
            >
              تفعيل مدفوع
              <img
                src="activate-icon.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            ,
            <Button
              variant="contained"
              color="primary"
              className="activationbtn2"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد القيام بهذه العملية",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleActiveunpaid(id);
                  },
                });
              }}
            >
              تفعيل غير مدفوع
              <img
                src="activate-icon2.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            ,
            <Button
              variant="contained"
              color="primary"
              className="viewbtn"
              onClick={handleView(id)}
            >
              استعراض
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="deletebtn"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد حذف هذه السجل؟",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleDeleteClick(id);
                  },
                });
              }}
            >
              حذف
              <img
                src="deleteicon.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            ,
          </Box>
        );
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default Order;
